export const NULL_GRID = [
    null,null,null,
    null,null,null,
    null,null,null
];

export const LOCAL_DATA_KEY = 'REACT_LOCAL_DATA_STORAGE_KEY';